module.exports = __webpack_public_path__ + "static/media/Picture1.f344ea0c.jpg";